import { useToast } from 'services/toast';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { SxProps, Typography } from '@mui/material';
import {
  CheckCircle,
  Cancel,
  WarningRounded,
  InfoRounded
} from '@mui/icons-material';

const container: SxProps = {
  zIndex: 1600,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  mt: 10,
  maxWidth: '800px'
};

export const Toast: React.FC = () => {
  const { toastState, hideToast } = useToast();

  const handleClose = () => {
    hideToast();
  };

  return (
    <Snackbar
      open={toastState.open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={container}
    >
      <Alert
        variant="filled"
        severity={toastState.type}
        onClose={handleClose}
        iconMapping={{
          success: <CheckCircle />,
          info: <InfoRounded />,
          error: <Cancel />,
          warning: <WarningRounded />
        }}
        sx={{
          ...toastState.sx,
          width: 'fit-content'
        }}
      >
        {toastState.title}

        {toastState.message && (
          <>
            {typeof toastState.message === 'string' && (
              <Typography
                variant="body2"
                mt={toastState.title ? 1 : 0}
                fontWeight="bold"
              >
                {toastState.message}
              </Typography>
            )}
            {typeof toastState.message !== 'string' && (
              <>{toastState.message}</>
            )}
          </>
        )}
      </Alert>
    </Snackbar>
  );
};
